<template>
  <div>
    <div>
      <img v-for="(thumbnail, index) in thumbnails" :key="index" :src="`data:image/png;base64,${thumbnail}`" :alt="index" :style="`position: absolute;z-index: ${index}`">
    </div>
    <div style="padding-top: 300px">
      <small>
        Sorry, the shared board is very small and hard to see due to the beta version...<br>
        When it's officially released, you'll be able to view it nicely on your browser.<br>
        Even in the beta version, iPad user can view and edit the shared board smoothly with other iPad users.<br>
        Download on the App Store! <a href="https://apps.apple.com/app/id1521209374">Here</a>
      </small><br><br><br>
      <small>
        すみません、β版の為共有されたボードがとても小さくて見にくいです・・・<br>
        正式リリース時には、ブラウザからでも綺麗に閲覧できるようになります<br>
        β版でもiPadユーザー同士であれば、共有ボードをスムーズに閲覧・編集できます<br>
        App Storeからダウンロード！ <a href="https://apps.apple.com/jp/app/id1521209374">こちら</a>
      </small>
    </div>
  </div>
</template>

<script>
  import * as firebase from "firebase";
  import router from "../router";

  export default {
    name: "BoardView",
    data() {
      return {
        thumbnails: [],
        interval: null,
      }
    },
    created() {
      let boardRef = firebase.firestore().doc(`boards/${this.$route.params.boardId}`);

      // 匿名認証
      firebase.auth().signInAnonymously();

      // アクセスログの作成（30秒ごと）
      boardRef.get().then((board) => {
        if (board.exists) {
          // TODO Permissionチェックを入れる
          this.interval = setInterval(() => {
            if (document.visibilityState === 'visible') { // ページタブがアクティブな状態の時だけログ更新
              firebase.auth().onAuthStateChanged(user => {
                if (user) {
                  let currentTime = new Date();
                  firebase.firestore().doc(`boards/${this.$route.params.boardId}/guestUsers/${user.uid}`).set({
                    lastVisitedTimesStamp: currentTime.getTime()
                  });
                }
              })
            }
          }, 30000);
        } else {
          router.push('/error/404');
        }
      });

      // サムネイルの表示
      this.unsubscribe = boardRef.collection('thumbnails').onSnapshot((thumbnailSnapshot) => {
        if (!thumbnailSnapshot.empty) {
          // 描画データの作成
          thumbnailSnapshot.docChanges().forEach(thumbnail => {
            if (thumbnail.type === 'added') {
              this.thumbnails.push(thumbnail.doc.data().thumbnail)
            }
          });
        }
      })
    },
    beforeDestroy() {
      if (this.unsubscribe) this.unsubscribe();
      if (this.interval) clearInterval(this.interval);
    },
  }
</script>